import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, IframeChatConfigResponseData } from "schema"
import { z } from "zod"

type Response = DataResponse<z.input<typeof IframeChatConfigResponseData>>
type OnSuccessFn = (data: Response["data"]) => void

export const getIframeChatConfigQueryKey = () => ["iframeChatConfig"]

type Props = {
  onSuccess?: OnSuccessFn
}

export const getIframeChatConfigQuery = ({ onSuccess }: Props = {}) => {
  return queryOptions({
    queryKey: getIframeChatConfigQueryKey(),
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/integrations/widget/iframe`)
      onSuccess?.(data.data)
      return data.data
    },
    refetchOnWindowFocus: false,
  })
}
